var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagPt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 138 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34179_35117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 0H0V92H138V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 0H0V92H55.2V0Z",
    fill: "#006600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1952 60.2693C66.2469 60.06 34.385 40.1719 34.1665 37.0048L35.9259 34.0707C39.0863 38.6629 71.6587 58.0045 74.858 57.3191L73.1951 60.2684",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1952 60.2693C66.2469 60.06 34.385 40.1719 34.1665 37.0048L35.9259 34.0707C39.0863 38.6629 71.6587 58.0045 74.858 57.3191L73.1951 60.2684",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5557 33.6721C34.9324 35.3497 43.8699 40.8753 54.6234 47.4155C65.3763 53.9554 74.6483 57.9969 75.3356 57.4173C75.3775 57.3425 75.6737 56.8329 75.6465 56.837C75.5177 57.0311 75.2041 57.0924 74.7149 56.9514C71.8097 56.1134 64.2326 52.6354 54.8489 46.945C45.4653 41.2541 37.3012 36.0099 36.0323 33.7816C35.9441 33.6273 35.8812 33.3455 35.894 33.1264L35.8632 33.126L35.593 33.5982L35.5559 33.6723L35.5557 33.6721ZM73.3585 60.3613C73.2406 60.5751 73.021 60.5822 72.6037 60.5364C70.0047 60.2487 62.1182 56.4136 52.7864 50.8274C41.9281 44.3276 32.9604 38.4051 33.9333 36.8572L34.1981 36.3892L34.2502 36.4055C33.3753 39.0286 51.9482 49.6484 53.0416 50.3255C63.7882 56.9833 72.8481 60.8712 73.6499 59.8609L73.3582 60.3625V60.362L73.3585 60.3613Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.239 38.923C62.1936 38.868 70.7755 37.9726 75.7143 36.0043L74.6502 34.2754C71.7311 35.8911 63.1019 36.9535 55.1803 37.1125C45.811 37.0263 39.1976 36.1538 35.884 33.9304L34.8795 35.7715C40.9708 38.3491 47.2127 38.8963 55.239 38.923Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0012 36.0434C75.8312 36.3152 72.6103 37.426 67.8654 38.2457C64.6482 38.7362 60.4516 39.1555 55.2145 39.1606C50.2389 39.1652 46.1743 38.811 43.0972 38.394C38.1163 37.613 35.5456 36.5264 34.5952 36.1424C34.6861 35.9616 34.7445 35.8349 34.8321 35.6661C37.568 36.7554 40.1507 37.4122 43.1763 37.8777C46.2332 38.2917 50.2488 38.651 55.1998 38.6463C60.4125 38.6411 64.5629 38.1899 67.7615 37.714C72.6271 36.9292 75.285 35.9193 75.6583 35.4503L76.0019 36.0434H76.0014H76.0012ZM75.0673 34.2902C74.5399 34.7137 71.9122 35.6456 67.289 36.384C64.2035 36.8262 60.2804 37.2219 55.268 37.2268C50.5061 37.2315 46.6156 36.9106 43.6565 36.4795C38.9612 35.8663 36.4623 34.7602 35.5614 34.4377C35.651 34.2827 35.7423 34.1289 35.836 33.9746C36.537 34.3275 38.9486 35.3065 43.708 35.9807C46.6336 36.3955 50.53 36.7047 55.2683 36.6998C60.257 36.6947 64.1355 36.2913 67.2014 35.8515C71.8485 35.2121 74.3491 34.0236 74.7288 33.7261L75.0675 34.2898L75.0673 34.2902Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4024 47.3018C36.6799 49.6025 46.1805 50.7619 55.171 50.8417C63.3569 50.8547 74.0213 49.5764 78.0093 47.463L77.8995 45.1603C76.6519 47.1101 65.2236 48.9803 55.0822 48.9038C44.9408 48.8273 35.5234 47.2609 32.3842 45.2332L32.4024 47.3012",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4024 47.3018C36.6799 49.6025 46.1805 50.7619 55.171 50.8417C63.3569 50.8547 74.0213 49.5764 78.0093 47.463L77.8995 45.1603C76.6519 47.1101 65.2236 48.9803 55.0822 48.9038C44.9408 48.8273 35.5234 47.2609 32.3842 45.2332L32.4024 47.3012",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2276 46.9706L78.2278 47.5198C77.6284 48.2364 73.8702 49.3196 69.1573 50.0824C65.5704 50.6323 60.8941 51.0471 55.067 51.0471C49.5312 51.0471 45.1166 50.6524 41.693 50.1268C36.2813 49.3388 32.8198 47.9588 32.125 47.5469L32.128 46.9063C34.2152 48.294 39.8701 49.3091 41.7689 49.6199C45.1702 50.142 49.5586 50.5337 55.0669 50.5337C60.8665 50.5337 65.5167 50.1217 69.081 49.5754C72.4622 49.087 77.2791 47.8168 78.2274 46.9709L78.2276 46.9706ZM78.2299 45.0174L78.2301 45.5665C77.6307 46.2828 73.8725 47.366 69.1596 48.1287C65.5728 48.6787 60.8964 49.0935 55.0693 49.0935C49.5335 49.0935 45.1189 48.6991 41.6953 48.1732C36.2836 47.3855 32.8221 46.0055 32.1273 45.5935L32.1303 44.9529C34.2175 46.3404 39.8724 47.3557 41.7712 47.666C45.1725 48.1885 49.5609 48.5804 55.0692 48.5804C60.8688 48.5804 65.519 48.1682 69.0833 47.6215C72.4645 47.1331 77.2814 45.8628 78.2297 45.017L78.2299 45.0174Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1517 59.8736C45.3141 59.815 36.8848 57.192 35.1049 56.7585L36.4028 58.7904C39.5469 60.113 47.7703 62.084 55.246 61.8657C62.7219 61.6477 69.2553 61.0686 73.8595 58.8272L75.1903 56.7214C72.0526 58.1992 61.3748 59.8584 55.1517 59.8736Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.359 58.3556C74.1634 58.6544 73.964 58.9496 73.7618 59.2364C71.5902 60.0021 68.1684 60.806 66.7245 61.0405C63.775 61.6482 59.2115 62.0971 55.1615 62.0992C46.4468 61.9716 39.3133 60.2656 35.9574 58.8104L35.6866 58.3449L35.7308 58.2749L36.1901 58.453C42.1581 60.5882 48.861 61.44 55.2106 61.5929C59.2443 61.6071 63.2824 61.1306 66.5478 60.5466C71.5551 59.5434 73.5798 58.7871 74.201 58.4443L74.359 58.3556ZM75.5129 56.4523C75.518 56.4582 75.5231 56.4639 75.5279 56.4701C75.3817 56.717 75.231 56.9681 75.0766 57.2205C73.9184 57.6345 70.7752 58.5542 66.1851 59.196C63.1608 59.608 61.281 60.007 55.2649 60.1238C43.9914 59.837 36.6924 57.6327 34.9584 57.089L34.7014 56.5961C41.2348 58.3016 47.9085 59.4922 55.2653 59.6139C60.7694 59.4967 63.111 59.0914 66.1102 58.6824C71.4625 57.8501 74.1593 56.969 74.9687 56.7146C74.9585 56.7 74.9466 56.6846 74.9332 56.6687L75.5135 56.4519L75.5129 56.4523Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.1265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6309 45.4848C75.6628 51.9563 72.3511 57.7636 69.6836 60.3256C65.9097 63.9502 60.9061 66.2817 55.0627 66.3891C48.5376 66.5089 42.3851 62.2551 40.7348 60.3863C37.5084 56.7328 34.8816 52.0932 34.7974 45.8404C35.197 38.7773 37.9698 33.8574 41.989 30.4835C46.0083 27.1097 51.3599 25.4666 55.8169 25.5841C60.9592 25.7198 66.9661 28.2424 71.1167 33.2504C73.836 36.5316 75.0136 40.0925 75.6309 45.4848ZM55.1181 23.3262C67.6497 23.3262 77.9562 33.5239 77.9562 46.0279C77.9562 58.5316 67.6497 68.7298 55.1181 68.7298C42.5866 68.7298 32.3656 58.5318 32.3656 46.0279C32.3656 33.5239 42.5866 23.3262 55.1181 23.3262Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1793 23.2484C67.7221 23.2484 77.9518 33.4795 77.9518 46.0235C77.9518 58.5672 67.7219 68.7981 55.1793 68.7981C42.6364 68.7981 32.4067 58.5674 32.4067 46.0235C32.4067 33.4795 42.6367 23.2484 55.1793 23.2484ZM32.9079 46.0236C32.9079 58.2734 42.9672 68.2972 55.1793 68.2972C67.3916 68.2972 77.4509 58.2734 77.4509 46.0236C77.4509 33.7733 67.3913 23.7494 55.1793 23.7494C42.9672 23.7494 32.9079 33.7738 32.9079 46.0236Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1976 25.1414C66.6358 25.1414 76.057 34.5302 76.057 46.0033C76.057 57.4766 66.6355 66.865 55.1976 66.865C43.7597 66.865 34.3383 57.4766 34.3383 46.0033C34.3383 34.5302 43.76 25.1414 55.1976 25.1414ZM34.8392 46.0031C34.8392 57.2007 44.0344 66.3637 55.1976 66.3637C66.3609 66.3637 75.5561 57.2007 75.5561 46.0031C75.5561 34.8054 66.3612 25.6424 55.1976 25.6424C44.0344 25.6424 34.8392 34.8054 34.8392 46.0031Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1153 23.1565H54.1637L54.166 68.9173H56.1243L56.1153 23.1565Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9198 22.8956H56.4166L56.4208 69.1831H55.9237L55.9198 22.8956ZM53.9829 22.896H54.4835L54.4842 69.1835H53.9832V22.896H53.9829Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9677 46.9051V45.2134L76.59 43.93L68.77 41.86L57.5 40.71L43.93 41.4L34.27 43.7L32.3196 45.1444V46.8365L37.26 44.62L48.99 42.78H60.26L68.54 43.7L74.29 45.08L77.9677 46.9051Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1885 42.4972C60.5665 42.4872 65.7846 43.0067 69.9234 43.8126C74.1943 44.6664 77.1999 45.7344 78.2276 46.934L78.2264 47.5279C76.9871 46.0351 72.9426 44.9408 69.8273 44.3152C65.7199 43.5162 60.5369 43.0004 55.1885 43.0103C49.5447 43.0209 44.2895 43.5554 40.2421 44.3451C36.9945 44.9895 32.6634 46.2697 32.1227 47.5324V46.9139C32.4196 46.0399 35.6447 44.7337 40.169 43.828C44.2467 43.0329 49.5116 42.5075 55.1885 42.4972ZM55.1908 40.544C60.5689 40.5342 65.7869 41.0539 69.9257 41.8594C74.1966 42.7136 77.2022 43.7812 78.2299 44.9808L78.2287 45.5747C76.9894 44.0823 72.9449 42.9879 69.8296 42.3625C65.7222 41.5631 60.5392 41.0472 55.1908 41.0576C49.547 41.0677 44.3173 41.6026 40.2695 42.3919C37.1355 42.986 32.6275 44.3169 32.1248 45.5797V44.9608C32.4217 44.0963 35.7121 42.7433 40.1713 41.8749C44.249 41.0797 49.5139 40.5547 55.1908 40.544Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0804 30.5809C63.5556 30.5385 70.9481 31.7659 74.3302 33.4984L75.5639 35.6326C72.6243 34.0484 64.649 32.4011 55.0927 32.6474C47.3063 32.6953 38.9865 33.5047 34.8123 35.7317L36.2851 33.2687C39.7109 31.4921 47.7901 30.5908 55.0807 30.5814",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0804 30.5809C63.5556 30.5385 70.9481 31.7659 74.3302 33.4984L75.5639 35.6326C72.6243 34.0484 64.649 32.4011 55.0927 32.6474C47.3063 32.6953 38.9865 33.5047 34.8123 35.7317L36.2851 33.2687C39.7109 31.4921 47.7901 30.5908 55.0807 30.5814",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1931 32.3427C60.027 32.3299 64.6978 32.6025 68.4125 33.2727C71.872 33.9166 75.1711 34.8829 75.6428 35.4026L76.0085 36.0489C74.8613 35.2998 72.0063 34.4657 68.3406 33.7705C64.6592 33.0786 59.9916 32.8494 55.1846 32.862C49.7285 32.8433 45.4896 33.1313 41.8517 33.7657C38.0043 34.4856 35.3349 35.514 34.6764 36.0027L35.0348 35.3195C36.3143 34.6667 38.3445 33.8799 41.7561 33.2656C45.5182 32.5784 49.8022 32.3723 55.1934 32.3427L55.1931 32.3427ZM55.191 30.3913C59.817 30.3791 64.3845 30.6369 67.9449 31.2769C70.753 31.8236 73.53 32.677 74.5469 33.4364L75.0818 34.2864C74.1724 33.2756 70.7495 32.3177 67.7277 31.7812C64.1947 31.1719 59.8169 30.9307 55.1909 30.8921C50.3361 30.9057 45.8494 31.2031 42.3679 31.837C39.0465 32.4691 36.9031 33.2174 35.9962 33.8018L36.4666 33.0918C37.7181 32.4329 39.74 31.8279 42.2863 31.3331C45.7936 30.6945 50.3076 30.4049 55.191 30.3913Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5044 55.4898C62.3143 54.7076 58.1165 54.594 55.1845 54.6285C41.0609 54.7941 36.4984 57.5286 35.9415 58.3566L34.886 56.6359C38.4818 54.0295 46.1728 52.5679 55.261 52.7174C59.9801 52.7946 64.0525 53.108 67.4784 53.7716L66.5041 55.4903",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5044 55.4898C62.3143 54.7076 58.1165 54.594 55.1845 54.6285C41.0609 54.7941 36.4984 57.5286 35.9415 58.3566L34.886 56.6359C38.4818 54.0295 46.1728 52.5679 55.261 52.7174C59.9801 52.7946 64.0525 53.108 67.4784 53.7716L66.5041 55.4903",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1034 54.3859C59.0322 54.4445 62.8886 54.6068 66.6109 55.3009L66.3414 55.7768C62.8843 55.1386 59.1987 54.8944 55.1167 54.9143C49.9042 54.8735 44.6321 55.3603 40.0423 56.6776C38.594 57.0807 36.1964 58.0118 35.9519 58.7812L35.6838 58.339C35.7611 57.8842 37.2101 56.9403 39.919 56.1792C45.1763 54.6737 50.094 54.4199 55.1034 54.3855L55.1034 54.3859ZM55.2817 52.4087C59.3522 52.4848 63.5559 52.673 67.6418 53.4824L67.3611 53.9777C63.6715 53.2452 60.1462 53.001 55.3057 52.9266C50.0766 52.9361 44.5299 53.309 39.4867 54.7751C37.8585 55.2494 35.0484 56.2748 34.9548 57.0866L34.6866 56.6116C34.7477 55.8742 37.1803 54.9123 39.369 54.2757C44.4511 52.7982 50.0121 52.4182 55.2817 52.4087Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.1265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3434 56.8974L73.6462 59.5307L68.77 55.2L56.12 46.69L41.86 38.87L34.4563 36.3377L36.0341 33.4121L36.57 33.12L41.17 34.27L56.35 42.09L65.09 47.61L72.45 52.9L75.44 56.35L75.3434 56.8974Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1895 36.4068C35.4881 35.526 45.0315 39.7774 55.0172 45.7986C64.9764 51.837 74.4929 58.6604 73.6338 59.9374L73.3513 60.3818L73.2216 60.4841C73.2494 60.4642 73.3926 60.2891 73.2076 59.8157C72.7833 58.4195 66.0328 53.0328 54.832 46.2698C43.9128 39.7588 34.8126 35.8345 33.9027 36.9562L34.1895 36.4068ZM75.6907 56.86C76.5118 55.238 67.66 48.5699 56.6853 42.0774C45.4584 35.7143 37.3667 31.9687 35.8887 33.0856L35.5604 33.6834C35.5575 33.7162 35.5723 33.6426 35.6417 33.5891C35.9104 33.3546 36.3559 33.3704 36.5569 33.3667C39.1019 33.4049 46.3703 36.7498 56.5683 42.5962C61.0367 45.1986 75.4446 54.4391 75.3896 57.0377C75.3935 57.261 75.4081 57.307 75.3241 57.4176L75.6907 56.86Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6907 56.86C76.5118 55.238 67.66 48.5699 56.6853 42.0774C45.4584 35.7143 37.3667 31.9687 35.8887 33.0856L35.5604 33.6834C35.5575 33.7162 35.5723 33.6426 35.6417 33.5891C35.9104 33.3546 36.3559 33.3704 36.5569 33.3667C39.1019 33.4049 46.3703 36.7498 56.5683 42.5962C61.0367 45.1986 75.4446 54.4391 75.3896 57.0377C75.3935 57.261 75.4081 57.307 75.3241 57.4176L75.6907 56.86ZM75.6907 56.86L75.6907 56.8597M34.1895 36.4068C35.4881 35.526 45.0315 39.7774 55.0172 45.7986C64.9764 51.837 74.4929 58.6604 73.6338 59.9374L73.3513 60.3818L73.2216 60.4841C73.2494 60.4642 73.3926 60.2891 73.2076 59.8157C72.7833 58.4195 66.0328 53.0328 54.832 46.2698C43.9128 39.7588 34.8126 35.8345 33.9027 36.9562L34.1895 36.4068Z",
    stroke: "black",
    strokeWidth: 0.13179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.538 48.5323C41.538 52.2746 43.0705 55.6593 45.5531 58.133C48.0406 60.6119 51.4209 62.1761 55.1692 62.1761C58.9368 62.1761 62.356 60.6461 64.8329 58.1767C67.3097 55.7076 68.8448 52.2997 68.8455 48.5443H68.845V30.3308L41.5348 30.2983L41.5376 48.5323L41.538 48.5323Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.154185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0486 48.5575V48.5679C42.0486 52.146 43.5301 55.4044 45.9069 57.77C48.2883 60.1401 51.5681 61.6137 55.1561 61.6137C58.7627 61.6137 62.0358 60.1508 64.4071 57.7897C66.778 55.4288 68.2475 52.1702 68.2479 48.5796H68.2474V30.9096L42.0642 30.9054L42.0482 48.5574M62.9833 36.1956L62.9842 47.4406L62.9747 48.63C62.9747 48.943 62.956 49.2999 62.9195 49.6037C62.7067 51.3815 61.8891 52.9311 60.6781 54.1365C59.2605 55.5478 57.3038 56.423 55.1473 56.423C53.0021 56.423 51.0904 55.5173 49.6667 54.1C48.2062 52.6464 47.3598 50.6533 47.3598 48.5922L47.3567 36.1669L62.9829 36.1951L62.9833 36.1956Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0486 48.5575V48.5679C42.0486 52.146 43.5301 55.4044 45.9069 57.77C48.2883 60.1401 51.5681 61.6137 55.1561 61.6137C58.7627 61.6137 62.0358 60.1508 64.4071 57.7897C66.778 55.4288 68.2475 52.1702 68.2479 48.5796H68.2474V30.9096L42.0642 30.9054L42.0482 48.5574M62.9833 36.1956L62.9842 47.4406L62.9747 48.63C62.9747 48.943 62.956 49.2999 62.9195 49.6037C62.7067 51.3815 61.8891 52.9311 60.6781 54.1365C59.2605 55.5478 57.3038 56.423 55.1473 56.423C53.0021 56.423 51.0904 55.5173 49.6667 54.1C48.2062 52.6464 47.3598 50.6533 47.3598 48.5922L47.3567 36.1669L62.9829 36.1951L62.9833 36.1956Z",
    stroke: "black",
    strokeWidth: 0.116688
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7437 35.5189C43.7747 34.2491 44.6757 33.9485 44.6822 33.944C44.6887 33.9398 45.6554 34.2678 45.6522 35.5307L43.7437 35.5189Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9662 33.9687L42.8094 35.428L43.7618 35.43C43.7709 34.2227 44.6758 34.0219 44.6977 34.0263C44.7182 34.0252 45.6151 34.2933 45.639 35.43H46.5938L46.4214 33.9596L42.9663 33.9683L42.9662 33.9687Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7455 35.4338H46.6431C46.7252 35.4338 46.7924 35.515 46.7924 35.6142C46.7924 35.7132 46.7252 35.7939 46.6431 35.7939H42.7455C42.6633 35.7939 42.5962 35.7132 42.5962 35.6142C42.5962 35.515 42.6633 35.4338 42.7455 35.4338Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1622 35.4269C44.1665 34.665 44.6825 34.4494 44.6852 34.4498C44.6854 34.4498 45.2239 34.6722 45.2282 35.4269H44.1622Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8283 33.3616H46.5646C46.6433 33.3616 46.7078 33.4348 46.7078 33.5236C46.7078 33.6127 46.6433 33.6857 46.5646 33.6857H42.8283C42.7496 33.6857 42.6851 33.6131 42.6851 33.5236C42.6851 33.4348 42.7496 33.3616 42.8283 33.3616Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9064 33.6881H46.4802C46.5554 33.6881 46.6171 33.7609 46.6171 33.85C46.6171 33.9392 46.5554 34.0121 46.4802 34.0121H42.9064C42.8312 34.0121 42.7695 33.9392 42.7695 33.85C42.7695 33.7609 42.8312 33.6881 42.9064 33.6881Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.061 31.2524L44.3432 31.2529V31.4533H44.549V31.2484L44.8381 31.2493V31.4534H45.0446V31.2485H45.3338L45.3334 31.7112C45.3334 31.7838 45.2749 31.8309 45.2072 31.8309H44.1926C44.1244 31.8309 44.0616 31.7763 44.0614 31.7098L44.0607 31.2526L44.061 31.2524Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1237 31.8712L45.1874 33.355L44.1978 33.3513L44.2633 31.8673L45.1237 31.8712Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9162 32.5588L43.9464 33.3587L42.9976 33.3591L43.0243 32.5589L43.9162 32.5588Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3563 32.5588L46.3865 33.3587L45.4376 33.3591L45.4644 32.5589L46.3563 32.5588Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.849 31.9792L43.1248 31.9799V32.1805H43.3267V31.9752L43.6094 31.9761V32.1806H43.8117V31.9753L44.0946 31.9758L44.0941 32.4385C44.0941 32.5107 44.0369 32.5578 43.9708 32.5578H42.9779C42.9114 32.5578 42.8495 32.5036 42.8493 32.4369L42.8486 31.9794L42.849 31.9792Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.289 31.9792L45.5649 31.9799V32.1805H45.7667V31.9752L46.0495 31.9761V32.1806H46.2517V31.9753L46.5347 31.9758L46.5342 32.4385C46.5342 32.5107 46.477 32.5578 46.4109 32.5578H45.418C45.3515 32.5578 45.2896 32.5036 45.2894 32.4369L45.2887 31.9794L45.289 31.9792Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5969 32.3403C44.5908 32.1961 44.7986 32.1945 44.7961 32.3403V32.6937H44.5969L44.5969 32.3403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3711 32.8533C43.3704 32.7139 43.5636 32.7111 43.5612 32.8533V33.1263H43.3712L43.3711 32.8533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8185 32.8533C45.8178 32.7139 46.011 32.7111 46.0085 32.8533V33.1263H45.8186L45.8185 32.8533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7437 46.1725C43.7747 44.9026 44.6757 44.602 44.6822 44.5976C44.6887 44.5933 45.6554 44.9213 45.6522 46.1843L43.7437 46.1725Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9662 44.6222L42.8094 46.0815L43.7618 46.0836C43.7709 44.8763 44.6758 44.6754 44.6977 44.6799C44.7182 44.6787 45.6151 44.9468 45.639 46.0836H46.5938L46.4214 44.6132L42.9663 44.6219L42.9662 44.6222Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7455 46.0874H46.6431C46.7252 46.0874 46.7924 46.1685 46.7924 46.2677C46.7924 46.3667 46.7252 46.4475 46.6431 46.4475H42.7455C42.6633 46.4475 42.5962 46.3667 42.5962 46.2677C42.5962 46.1685 42.6633 46.0874 42.7455 46.0874Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1622 46.0805C44.1665 45.3186 44.6825 45.103 44.6852 45.1034C44.6854 45.1034 45.2239 45.3257 45.2282 46.0805H44.1622Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8283 44.0151H46.5646C46.6433 44.0151 46.7078 44.0884 46.7078 44.1772C46.7078 44.2663 46.6433 44.3393 46.5646 44.3393H42.8283C42.7496 44.3393 42.6851 44.2667 42.6851 44.1772C42.6851 44.0884 42.7496 44.0151 42.8283 44.0151Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9064 44.3417H46.4802C46.5554 44.3417 46.6171 44.4145 46.6171 44.5035C46.6171 44.5928 46.5554 44.6656 46.4802 44.6656H42.9064C42.8312 44.6656 42.7695 44.5928 42.7695 44.5035C42.7695 44.4145 42.8312 44.3417 42.9064 44.3417Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.061 41.906L44.3432 41.9064V42.1069H44.549V41.902L44.8381 41.9029V42.107H45.0446V41.9021H45.3338L45.3334 42.3648C45.3334 42.4374 45.2749 42.4845 45.2072 42.4845H44.1926C44.1244 42.4845 44.0616 42.4299 44.0614 42.3634L44.0607 41.9061L44.061 41.906Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1237 42.5247L45.1874 44.0086L44.1978 44.0049L44.2633 42.5209L45.1237 42.5247Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9162 43.2124L43.9464 44.0122L42.9976 44.0127L43.0243 43.2124L43.9162 43.2124Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3563 43.2124L46.3865 44.0122L45.4376 44.0127L45.4644 43.2124L46.3563 43.2124Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.849 42.6328L43.1248 42.6335V42.8341H43.3267V42.6288L43.6094 42.6297V42.8342H43.8117V42.6289L44.0946 42.6294L44.0941 43.092C44.0941 43.1643 44.0369 43.2113 43.9708 43.2113H42.9779C42.9114 43.2113 42.8495 43.1572 42.8493 43.0904L42.8486 42.633L42.849 42.6328Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.289 42.6328L45.5649 42.6335V42.8341H45.7667V42.6288L46.0495 42.6297V42.8342H46.2517V42.6289L46.5347 42.6294L46.5342 43.092C46.5342 43.1643 46.477 43.2113 46.4109 43.2113H45.418C45.3515 43.2113 45.2896 43.1572 45.2894 43.0904L45.2887 42.633L45.289 42.6328Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5969 42.9939C44.5908 42.8497 44.7986 42.8481 44.7961 42.9939V43.3473H44.5969L44.5969 42.9939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3711 43.5068C43.3704 43.3675 43.5636 43.3646 43.5612 43.5068V43.7799H43.3712L43.3711 43.5068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8185 43.5068C45.8178 43.3675 46.011 43.3646 46.0085 43.5068V43.7799H45.8186L45.8185 43.5068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8977 57.2617C47.0185 56.3449 47.4401 55.4938 47.4415 55.486C47.443 55.4784 48.357 55.0235 49.2508 55.9157L47.8977 57.2617Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.25 56.7211L47.175 57.8606L47.8475 57.1862C46.9972 56.3291 47.4923 55.5455 47.5109 55.5331C47.5245 55.5177 48.3467 55.0701 49.1702 55.8541L49.843 55.1767L48.6781 54.2629L46.2498 56.7207L46.25 56.7211Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.134 57.9101L49.8803 55.1443C49.9382 55.0861 50.043 55.0956 50.1134 55.1655C50.1837 55.2352 50.1936 55.3398 50.1358 55.398L47.3895 58.1638C47.3316 58.222 47.227 58.2128 47.1568 58.1431C47.0864 58.0732 47.0761 57.9683 47.134 57.9101Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1273 56.8998C47.5897 56.3599 47.8003 55.8418 47.8024 55.8402C47.8026 55.8401 48.3398 55.6146 48.8784 56.1434L48.1273 56.8998Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7219 56.3911L48.3545 53.7398C48.41 53.6839 48.5074 53.6897 48.5705 53.7523C48.6336 53.8151 48.64 53.9123 48.5846 53.9682L45.9519 56.6195C45.8964 56.6753 45.7995 56.6699 45.736 56.6069C45.6729 56.5443 45.6664 56.4469 45.7219 56.3911Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0087 56.5658L48.5268 54.0299C48.5798 53.9765 48.6749 53.9841 48.7381 54.0468C48.8015 54.1097 48.8097 54.2048 48.7567 54.2582L46.2386 56.7941C46.1856 56.8475 46.0904 56.8399 46.0271 56.777C45.9639 56.7143 45.9557 56.6192 46.0087 56.5658Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0939 54.0303L45.293 53.8304L45.4352 53.9716L45.5803 53.8255L45.4349 53.6812L45.6392 53.4767L45.784 53.6205L45.9295 53.474L45.7842 53.3296L45.988 53.1244L46.316 53.4507C46.3675 53.5019 46.3597 53.5765 46.312 53.6246L45.5971 54.3445C45.5491 54.3929 45.4661 54.3991 45.4187 54.3523L45.0938 54.0306L45.0939 54.0303Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2816 53.7121L47.3794 54.7124L46.6795 55.4121L45.6726 54.32L46.2816 53.7121Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9188 55.0536L46.5076 55.5957L45.8394 56.2693L45.2904 55.6865L45.9188 55.0536Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.638 53.3221L48.2269 53.8642L47.5586 54.5379L47.0096 53.955L47.638 53.3221Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7555 55.4025L44.9504 55.2072L45.0927 55.3486L45.2349 55.2053L45.0893 55.0607L45.2892 54.8607L45.4342 55.0048L45.5767 54.8613L45.4311 54.7166L45.6308 54.5162L45.9588 54.8425C46.01 54.8934 46.0031 54.9671 45.9565 55.0141L45.2569 55.7186C45.21 55.7658 45.128 55.7716 45.0805 55.7247L44.7554 55.4029L44.7555 55.4025Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4749 53.671L46.6697 53.4758L46.8121 53.6171L46.9543 53.4739L46.8086 53.3293L47.0085 53.1293L47.1536 53.2733L47.2961 53.1298L47.1504 52.9852L47.3501 52.7847L47.6781 53.1111C47.7294 53.162 47.7225 53.2357 47.6759 53.2826L46.9763 53.9872C46.9294 54.0344 46.8474 54.0401 46.7999 53.9932L46.4748 53.6714L46.4749 53.671Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2434 54.4165C46.1368 54.3192 46.282 54.1707 46.3838 54.2752L46.6345 54.5242L46.4942 54.6655L46.2434 54.4165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7436 55.6478C45.6443 55.5501 45.7784 55.411 45.8775 55.5129L46.0713 55.7053L45.9374 55.8401L45.7436 55.6478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4681 53.9111C47.3687 53.8134 47.5028 53.6743 47.602 53.7762L47.7958 53.9686L47.6619 54.1034L47.4681 53.9111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2578 35.5189C54.2888 34.2491 55.1899 33.9485 55.1963 33.944C55.2028 33.9398 56.1696 34.2678 56.1663 35.5307L54.2578 35.5189Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4804 33.9687L53.3236 35.428L54.2759 35.43C54.2851 34.2227 55.1899 34.0219 55.2118 34.0263C55.2323 34.0252 56.1293 34.2933 56.1532 35.43H57.108L56.9355 33.9596L53.4805 33.9683L53.4804 33.9687Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2596 35.4338H57.1572C57.2394 35.4338 57.3065 35.515 57.3065 35.6142C57.3065 35.7132 57.2394 35.7939 57.1572 35.7939H53.2596C53.1775 35.7939 53.1104 35.7132 53.1104 35.6142C53.1104 35.515 53.1775 35.4338 53.2596 35.4338Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6764 35.4269C54.6806 34.665 55.1967 34.4494 55.1993 34.4498C55.1995 34.4498 55.7381 34.6722 55.7423 35.4269H54.6764Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3424 33.3616H57.0788C57.1575 33.3616 57.222 33.4348 57.222 33.5236C57.222 33.6127 57.1575 33.6857 57.0788 33.6857H53.3424C53.2637 33.6857 53.1992 33.6131 53.1992 33.5236C53.1992 33.4348 53.2637 33.3616 53.3424 33.3616Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4206 33.6881H56.9943C57.0696 33.6881 57.1313 33.7609 57.1313 33.85C57.1313 33.9392 57.0696 34.0121 56.9943 34.0121H53.4206C53.3454 34.0121 53.2837 33.9392 53.2837 33.85C53.2837 33.7609 53.3454 33.6881 53.4206 33.6881Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5752 31.2524L54.8573 31.2529V31.4533H55.0632V31.2484L55.3522 31.2493V31.4534H55.5587V31.2485H55.848L55.8475 31.7112C55.8475 31.7838 55.7891 31.8309 55.7214 31.8309H54.7068C54.6386 31.8309 54.5757 31.7763 54.5755 31.7098L54.5748 31.2526L54.5752 31.2524Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6379 31.8712L55.7016 33.355L54.7119 33.3513L54.7774 31.8673L55.6379 31.8712Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4304 32.5588L54.4606 33.3587L53.5117 33.3591L53.5385 32.5589L54.4304 32.5588Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8704 32.5588L56.9007 33.3587L55.9518 33.3591L55.9786 32.5589L56.8704 32.5588Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 31.9792L53.639 31.9799V32.1805H53.8408V31.9752L54.1236 31.9761V32.1806H54.3258V31.9753L54.6088 31.9758L54.6083 32.4385C54.6083 32.5107 54.5511 32.5578 54.485 32.5578H53.4921C53.4256 32.5578 53.3637 32.5036 53.3635 32.4369L53.3628 31.9794L53.3631 31.9792Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8032 31.9792L56.0791 31.9799V32.1805H56.2809V31.9752L56.5636 31.9761V32.1806H56.7659V31.9753L57.0488 31.9758L57.0484 32.4385C57.0484 32.5107 56.9912 32.5578 56.925 32.5578H55.9321C55.8656 32.5578 55.8038 32.5036 55.8035 32.4369L55.8029 31.9794L55.8032 31.9792Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1111 32.3403C55.105 32.1961 55.3127 32.1945 55.3103 32.3403V32.6937H55.1111L55.1111 32.3403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8853 32.8533C53.8846 32.7139 54.0777 32.7111 54.0753 32.8533V33.1263H53.8853L53.8853 32.8533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3326 32.8533C56.332 32.7139 56.5251 32.7111 56.5227 32.8533V33.1263H56.3327L56.3326 32.8533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6085 35.5189C66.5775 34.2491 65.6765 33.9485 65.67 33.944C65.6635 33.9398 64.6968 34.2678 64.7 35.5307L66.6085 35.5189Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3859 33.9687L67.5427 35.428L66.5904 35.43C66.5813 34.2227 65.6764 34.0219 65.6545 34.0263C65.634 34.0252 64.737 34.2933 64.7131 35.43H63.7584L63.9308 33.9596L67.3858 33.9683L67.3859 33.9687Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6067 35.4338H63.7091C63.627 35.4338 63.5598 35.515 63.5598 35.6142C63.5598 35.7132 63.627 35.7939 63.7091 35.7939H67.6067C67.6888 35.7939 67.756 35.7132 67.756 35.6142C67.756 35.515 67.6888 35.4338 67.6067 35.4338Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1899 35.4269C66.1857 34.665 65.6697 34.4494 65.667 34.4498C65.6668 34.4498 65.1283 34.6722 65.124 35.4269H66.1899Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5239 33.3616H63.7876C63.7089 33.3616 63.6444 33.4348 63.6444 33.5236C63.6444 33.6127 63.7089 33.6857 63.7876 33.6857H67.5239C67.6026 33.6857 67.6671 33.6131 67.6671 33.5236C67.6671 33.4348 67.6026 33.3616 67.5239 33.3616Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4457 33.6881H63.872C63.7967 33.6881 63.7351 33.7609 63.7351 33.85C63.7351 33.9392 63.7967 34.0121 63.872 34.0121H67.4457C67.521 34.0121 67.5826 33.9392 67.5826 33.85C67.5826 33.7609 67.521 33.6881 67.4457 33.6881Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2911 31.2524L66.009 31.2529V31.4533H65.8031V31.2484L65.5141 31.2493V31.4534H65.3076V31.2485H65.0184L65.0188 31.7112C65.0188 31.7838 65.0772 31.8309 65.145 31.8309H66.1596C66.2277 31.8309 66.2906 31.7763 66.2908 31.7098L66.2915 31.2526L66.2911 31.2524Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2285 31.8712L65.1648 33.355L66.1544 33.3513L66.0889 31.8673L65.2285 31.8712Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.436 32.5588L66.4057 33.3587L67.3546 33.3591L67.3278 32.5589L66.436 32.5588Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9959 32.5588L63.9657 33.3587L64.9146 33.3591L64.8878 32.5589L63.9959 32.5588Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5032 31.9792L67.2273 31.9799V32.1805H67.0255V31.9752L66.7428 31.9761V32.1806H66.5405V31.9753L66.2576 31.9758L66.258 32.4385C66.258 32.5107 66.3152 32.5578 66.3814 32.5578H67.3742C67.4408 32.5578 67.5026 32.5036 67.5028 32.4369L67.5035 31.9794L67.5032 31.9792Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0631 31.9792L64.7873 31.9799V32.1805H64.5854V31.9752L64.3027 31.9761V32.1806H64.1005V31.9753L63.8175 31.9758L63.818 32.4385C63.818 32.5107 63.8752 32.5578 63.9413 32.5578H64.9342C65.0007 32.5578 65.0626 32.5036 65.0628 32.4369L65.0635 31.9794L65.0631 31.9792Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7552 32.3403C65.7613 32.1961 65.5536 32.1945 65.556 32.3403V32.6937H65.7552L65.7552 32.3403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9811 32.8533C66.9818 32.7139 66.7886 32.7111 66.791 32.8533V33.1263H66.981L66.9811 32.8533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5337 32.8533C64.5344 32.7139 64.3412 32.7111 64.3436 32.8533V33.1263H64.5336L64.5337 32.8533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6085 46.1725C66.5775 44.9026 65.6765 44.602 65.67 44.5976C65.6635 44.5933 64.6968 44.9213 64.7 46.1843L66.6085 46.1725Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3859 44.6222L67.5427 46.0815L66.5904 46.0836C66.5813 44.8763 65.6764 44.6754 65.6545 44.6799C65.634 44.6787 64.737 44.9468 64.7131 46.0836H63.7584L63.9308 44.6132L67.3858 44.6219L67.3859 44.6222Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6067 46.0874H63.7091C63.627 46.0874 63.5598 46.1685 63.5598 46.2677C63.5598 46.3667 63.627 46.4475 63.7091 46.4475H67.6067C67.6888 46.4475 67.756 46.3667 67.756 46.2677C67.756 46.1685 67.6888 46.0874 67.6067 46.0874Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1899 46.0805C66.1857 45.3186 65.6697 45.103 65.667 45.1034C65.6668 45.1034 65.1283 45.3257 65.124 46.0805H66.1899Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5239 44.0151H63.7876C63.7089 44.0151 63.6444 44.0884 63.6444 44.1772C63.6444 44.2663 63.7089 44.3393 63.7876 44.3393H67.5239C67.6026 44.3393 67.6671 44.2667 67.6671 44.1772C67.6671 44.0884 67.6026 44.0151 67.5239 44.0151Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4457 44.3417H63.872C63.7967 44.3417 63.7351 44.4145 63.7351 44.5035C63.7351 44.5928 63.7967 44.6656 63.872 44.6656H67.4457C67.521 44.6656 67.5826 44.5928 67.5826 44.5035C67.5826 44.4145 67.521 44.3417 67.4457 44.3417Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2911 41.906L66.009 41.9064V42.1069H65.8031V41.902L65.5141 41.9029V42.107H65.3076V41.9021H65.0184L65.0188 42.3648C65.0188 42.4374 65.0772 42.4845 65.145 42.4845H66.1596C66.2277 42.4845 66.2906 42.4299 66.2908 42.3634L66.2915 41.9061L66.2911 41.906Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2285 42.5247L65.1648 44.0086L66.1544 44.0049L66.0889 42.5209L65.2285 42.5247Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.436 43.2124L66.4057 44.0122L67.3546 44.0127L67.3278 43.2124L66.436 43.2124Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9959 43.2124L63.9657 44.0122L64.9146 44.0127L64.8878 43.2124L63.9959 43.2124Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5032 42.6328L67.2273 42.6335V42.8341H67.0255V42.6288L66.7428 42.6297V42.8342H66.5405V42.6289L66.2576 42.6294L66.258 43.092C66.258 43.1643 66.3152 43.2113 66.3814 43.2113H67.3742C67.4408 43.2113 67.5026 43.1572 67.5028 43.0904L67.5035 42.633L67.5032 42.6328Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0631 42.6328L64.7873 42.6335V42.8341H64.5854V42.6288L64.3027 42.6297V42.8342H64.1005V42.6289L63.8175 42.6294L63.818 43.092C63.818 43.1643 63.8752 43.2113 63.9413 43.2113H64.9342C65.0007 43.2113 65.0626 43.1572 65.0628 43.0904L65.0635 42.633L65.0631 42.6328Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7552 42.9939C65.7613 42.8497 65.5536 42.8481 65.556 42.9939V43.3473H65.7552L65.7552 42.9939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9811 43.5068C66.9818 43.3675 66.7886 43.3646 66.791 43.5068V43.7799H66.981L66.9811 43.5068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5337 43.5068C64.5344 43.3675 64.3412 43.3646 64.3436 43.5068V43.7799H64.5336L64.5337 43.5068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4544 57.2617C63.3336 56.3449 62.9121 55.4938 62.9107 55.486C62.9091 55.4784 61.9952 55.0235 61.1013 55.9157L62.4544 57.2617Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1022 56.7211L63.1772 57.8606L62.5047 57.1862C63.355 56.3291 62.8599 55.5455 62.8413 55.5331C62.8277 55.5177 62.0054 55.0701 61.1819 55.8541L60.5092 55.1767L61.6741 54.2629L64.1024 56.7207L64.1022 56.7211Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2182 57.9101L60.4719 55.1443C60.414 55.0861 60.3091 55.0956 60.2388 55.1655C60.1685 55.2352 60.1585 55.3398 60.2164 55.398L62.9627 58.1638C63.0206 58.222 63.1252 58.2128 63.1954 58.1431C63.2658 58.0732 63.2761 57.9683 63.2182 57.9101Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2249 56.8998C62.7625 56.3599 62.5519 55.8418 62.5498 55.8402C62.5496 55.8401 62.0124 55.6146 61.4738 56.1434L62.2249 56.8998Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6303 56.3911L61.9976 53.7398C61.9422 53.6839 61.8448 53.6897 61.7817 53.7523C61.7185 53.8151 61.7122 53.9123 61.7676 53.9682L64.4003 56.6195C64.4557 56.6753 64.5527 56.6699 64.6162 56.6069C64.6792 56.5443 64.6858 56.4469 64.6303 56.3911Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3435 56.5658L61.8254 54.0299C61.7724 53.9765 61.6772 53.9841 61.614 54.0468C61.5507 54.1097 61.5425 54.2048 61.5955 54.2582L64.1136 56.7941C64.1666 56.8475 64.2617 56.8399 64.3251 56.777C64.3883 56.7143 64.3965 56.6192 64.3435 56.5658Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2583 54.0303L65.0591 53.8304L64.9169 53.9716L64.7719 53.8255L64.9172 53.6812L64.7129 53.4767L64.5681 53.6205L64.4226 53.474L64.568 53.3296L64.3642 53.1244L64.0362 53.4507C63.9847 53.5019 63.9924 53.5765 64.0402 53.6246L64.7551 54.3445C64.8031 54.3929 64.8861 54.3991 64.9335 54.3523L65.2584 54.0306L65.2583 54.0303Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0705 53.7121L62.9727 54.7124L63.6726 55.4121L64.6795 54.32L64.0705 53.7121Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4334 55.0536L63.8445 55.5957L64.5128 56.2693L65.0618 55.6865L64.4334 55.0536Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7142 53.3221L62.1253 53.8642L62.7936 54.5379L63.3426 53.955L62.7142 53.3221Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5967 55.4025L65.4018 55.2072L65.2594 55.3486L65.1172 55.2053L65.2629 55.0607L65.063 54.8607L64.9179 55.0048L64.7754 54.8613L64.9211 54.7166L64.7214 54.5162L64.3934 54.8425C64.3422 54.8934 64.3491 54.9671 64.3957 55.0141L65.0953 55.7186C65.1421 55.7658 65.2242 55.7716 65.2717 55.7247L65.5967 55.4029L65.5967 55.4025Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8773 53.671L63.6824 53.4758L63.5401 53.6171L63.3979 53.4739L63.5435 53.3293L63.3437 53.1293L63.1986 53.2733L63.0561 53.1298L63.2017 52.9852L63.0021 52.7847L62.674 53.1111C62.6228 53.162 62.6297 53.2357 62.6763 53.2826L63.3759 53.9872C63.4228 54.0344 63.5048 54.0401 63.5523 53.9932L63.8774 53.6714L63.8773 53.671Z",
    fill: "#FFFF00",
    stroke: "black",
    strokeWidth: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1088 54.4165C64.2154 54.3192 64.0702 54.1707 63.9684 54.2752L63.7177 54.5242L63.858 54.6655L64.1088 54.4165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6085 55.6478C64.7079 55.5501 64.5738 55.411 64.4746 55.5129L64.2809 55.7053L64.4147 55.8401L64.6085 55.6478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8841 53.9111C62.9834 53.8134 62.8493 53.6743 62.7501 53.7762L62.5564 53.9686L62.6903 54.1034L62.8841 53.9111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5063 46.5533V46.5545C53.5063 47.0632 53.7017 47.5268 54.0151 47.8631C54.329 48.2004 54.7615 48.4099 55.2345 48.4099C55.71 48.4099 56.1416 48.2018 56.4542 47.8659C56.7665 47.5304 56.9607 47.0673 56.9607 46.5565V44.0799L53.5125 44.077L53.5063 46.5533Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2971 45.3608C54.4859 45.3608 54.6389 45.2078 54.6389 45.019C54.6389 44.8303 54.4859 44.6772 54.2971 44.6772C54.1083 44.6772 53.9553 44.8303 53.9553 45.019C53.9553 45.2078 54.1083 45.3608 54.2971 45.3608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2102 45.3624C56.3989 45.3624 56.552 45.2094 56.552 45.0206C56.552 44.8319 56.3989 44.6788 56.2102 44.6788C56.0214 44.6788 55.8684 44.8319 55.8684 45.0206C55.8684 45.2094 56.0214 45.3624 56.2102 45.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2518 46.2809C55.4406 46.2809 55.5936 46.1278 55.5936 45.9391C55.5936 45.7503 55.4406 45.5973 55.2518 45.5973C55.0631 45.5973 54.91 45.7503 54.91 45.9391C54.91 46.1278 55.0631 46.2809 55.2518 46.2809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2971 47.2424C54.4859 47.2424 54.6389 47.0894 54.6389 46.9006C54.6389 46.7119 54.4859 46.5588 54.2971 46.5588C54.1083 46.5588 53.9553 46.7119 53.9553 46.9006C53.9553 47.0894 54.1083 47.2424 54.2971 47.2424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2081 47.2398C56.3969 47.2398 56.5499 47.0868 56.5499 46.8981C56.5499 46.7093 56.3969 46.5563 56.2081 46.5563C56.0194 46.5563 55.8663 46.7093 55.8663 46.8981C55.8663 47.0868 56.0194 47.2398 56.2081 47.2398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5063 40.5697V40.5708C53.5063 41.0796 53.7017 41.5431 54.0151 41.8794C54.329 42.2168 54.7615 42.4263 55.2345 42.4263C55.71 42.4263 56.1416 42.2182 56.4542 41.8822C56.7665 41.5467 56.9607 41.0836 56.9607 40.5729V38.0962L53.5125 38.0934L53.5063 40.5697Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2971 39.3772C54.4859 39.3772 54.6389 39.2241 54.6389 39.0354C54.6389 38.8466 54.4859 38.6936 54.2971 38.6936C54.1083 38.6936 53.9553 38.8466 53.9553 39.0354C53.9553 39.2241 54.1083 39.3772 54.2971 39.3772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2102 39.3788C56.3989 39.3788 56.552 39.2257 56.552 39.037C56.552 38.8482 56.3989 38.6952 56.2102 38.6952C56.0214 38.6952 55.8684 38.8482 55.8684 39.037C55.8684 39.2257 56.0214 39.3788 56.2102 39.3788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2518 40.2972C55.4406 40.2972 55.5936 40.1442 55.5936 39.9554C55.5936 39.7667 55.4406 39.6136 55.2518 39.6136C55.0631 39.6136 54.91 39.7667 54.91 39.9554C54.91 40.1442 55.0631 40.2972 55.2518 40.2972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2971 41.2588C54.4859 41.2588 54.6389 41.1057 54.6389 40.917C54.6389 40.7282 54.4859 40.5752 54.2971 40.5752C54.1083 40.5752 53.9553 40.7282 53.9553 40.917C53.9553 41.1057 54.1083 41.2588 54.2971 41.2588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2081 41.2562C56.3969 41.2562 56.5499 41.1032 56.5499 40.9144C56.5499 40.7257 56.3969 40.5726 56.2081 40.5726C56.0194 40.5726 55.8663 40.7257 55.8663 40.9144C55.8663 41.1032 56.0194 41.2562 56.2081 41.2562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7225 46.5533V46.5545C48.7225 47.0632 48.9179 47.5268 49.2312 47.8631C49.5452 48.2004 49.9777 48.4099 50.4507 48.4099C50.9262 48.4099 51.3578 48.2018 51.6704 47.8659C51.9827 47.5304 52.1769 47.0673 52.1769 46.5565V44.0799L48.7287 44.077L48.7225 46.5533Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5133 45.3608C49.7021 45.3608 49.8551 45.2078 49.8551 45.019C49.8551 44.8303 49.7021 44.6772 49.5133 44.6772C49.3245 44.6772 49.1715 44.8303 49.1715 45.019C49.1715 45.2078 49.3245 45.3608 49.5133 45.3608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4264 45.3624C51.6151 45.3624 51.7682 45.2094 51.7682 45.0206C51.7682 44.8319 51.6151 44.6788 51.4264 44.6788C51.2376 44.6788 51.0846 44.8319 51.0846 45.0206C51.0846 45.2094 51.2376 45.3624 51.4264 45.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.468 46.2809C50.6568 46.2809 50.8098 46.1278 50.8098 45.9391C50.8098 45.7503 50.6568 45.5973 50.468 45.5973C50.2792 45.5973 50.1262 45.7503 50.1262 45.9391C50.1262 46.1278 50.2792 46.2809 50.468 46.2809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5133 47.2424C49.7021 47.2424 49.8551 47.0894 49.8551 46.9006C49.8551 46.7119 49.7021 46.5588 49.5133 46.5588C49.3245 46.5588 49.1715 46.7119 49.1715 46.9006C49.1715 47.0894 49.3245 47.2424 49.5133 47.2424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4243 47.2398C51.6131 47.2398 51.7661 47.0868 51.7661 46.8981C51.7661 46.7093 51.6131 46.5563 51.4243 46.5563C51.2355 46.5563 51.0825 46.7093 51.0825 46.8981C51.0825 47.0868 51.2355 47.2398 51.4243 47.2398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2776 46.5533V46.5545C58.2776 47.0632 58.4729 47.5268 58.7863 47.8631C59.1003 48.2004 59.5327 48.4099 60.0058 48.4099C60.4812 48.4099 60.9129 48.2018 61.2254 47.8659C61.5378 47.5304 61.7319 47.0673 61.7319 46.5565V44.0799L58.2837 44.077L58.2776 46.5533Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0683 45.3608C59.2571 45.3608 59.4101 45.2078 59.4101 45.019C59.4101 44.8303 59.2571 44.6772 59.0683 44.6772C58.8796 44.6772 58.7266 44.8303 58.7266 45.019C58.7266 45.2078 58.8796 45.3608 59.0683 45.3608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9814 45.3624C61.1702 45.3624 61.3232 45.2094 61.3232 45.0206C61.3232 44.8319 61.1702 44.6788 60.9814 44.6788C60.7927 44.6788 60.6396 44.8319 60.6396 45.0206C60.6396 45.2094 60.7927 45.3624 60.9814 45.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0231 46.2809C60.2118 46.2809 60.3648 46.1278 60.3648 45.9391C60.3648 45.7503 60.2118 45.5973 60.0231 45.5973C59.8343 45.5973 59.6813 45.7503 59.6813 45.9391C59.6813 46.1278 59.8343 46.2809 60.0231 46.2809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0683 47.2424C59.2571 47.2424 59.4101 47.0894 59.4101 46.9006C59.4101 46.7119 59.2571 46.5588 59.0683 46.5588C58.8796 46.5588 58.7266 46.7119 58.7266 46.9006C58.7266 47.0894 58.8796 47.2424 59.0683 47.2424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9794 47.2398C61.1681 47.2398 61.3211 47.0868 61.3211 46.8981C61.3211 46.7093 61.1681 46.5563 60.9794 46.5563C60.7906 46.5563 60.6376 46.7093 60.6376 46.8981C60.6376 47.0868 60.7906 47.2398 60.9794 47.2398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5063 52.4838V52.4849C53.5063 52.9936 53.7017 53.4572 54.0151 53.7935C54.329 54.1308 54.7615 54.3403 55.2345 54.3403C55.71 54.3403 56.1416 54.1322 56.4542 53.7963C56.7665 53.4608 56.9607 52.9977 56.9607 52.4869V50.0103L53.5125 50.0074L53.5063 52.4838Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2971 51.2912C54.4859 51.2912 54.6389 51.1382 54.6389 50.9494C54.6389 50.7607 54.4859 50.6077 54.2971 50.6077C54.1083 50.6077 53.9553 50.7607 53.9553 50.9494C53.9553 51.1382 54.1083 51.2912 54.2971 51.2912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2102 51.2928C56.3989 51.2928 56.552 51.1398 56.552 50.951C56.552 50.7623 56.3989 50.6093 56.2102 50.6093C56.0214 50.6093 55.8684 50.7623 55.8684 50.951C55.8684 51.1398 56.0214 51.2928 56.2102 51.2928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2518 52.2113C55.4406 52.2113 55.5936 52.0583 55.5936 51.8695C55.5936 51.6807 55.4406 51.5277 55.2518 51.5277C55.0631 51.5277 54.91 51.6807 54.91 51.8695C54.91 52.0583 55.0631 52.2113 55.2518 52.2113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2971 53.1728C54.4859 53.1728 54.6389 53.0198 54.6389 52.831C54.6389 52.6423 54.4859 52.4893 54.2971 52.4893C54.1083 52.4893 53.9553 52.6423 53.9553 52.831C53.9553 53.0198 54.1083 53.1728 54.2971 53.1728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2081 53.1704C56.3969 53.1704 56.5499 53.0174 56.5499 52.8286C56.5499 52.6398 56.3969 52.4868 56.2081 52.4868C56.0194 52.4868 55.8663 52.6398 55.8663 52.8286C55.8663 53.0174 56.0194 53.1704 56.2081 53.1704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34179_35117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPt);
export default __webpack_public_path__ + "static/media/Flag_PT.c8e76284b7398cf6343d27ac90225768.svg";
export { ForwardRef as ReactComponent };